/* global window */
import React from "react";
import {
  TouchableOpacity,
  StyleSheet,
  Platform,
  ActivityIndicator,
  View
} from "react-native";
import Analytics from "src/backend/analytics";
import Util from "src/utility";
import Glob from "src/globalConstants";
import Rex from "src/globalState";
import Icon from "src/components/Icon";

const { width } = Glob.get("dimensions");
const ICON_SIZE = Math.min(
  0.07 * width,
  Glob.deviceHasTabletDimensions() ? 42 : 26
);

export default function NavBarButton({
  type = "icon", // "icon", "help", "loading", or "custom"
  data = {},
  style = {},
  onPress,
  navigation,
  customContent = null,
  position = "right" // "left", "right", "leftInner", or "rightInner"
}) {
  const { icon } = data;
  const buttonColor = Rex.getConfig()?.colors?.navbarText || "white";
  let positionStyle = {};
  if (position === "right") {
    positionStyle = {
      alignItems: "flex-end",
      paddingRight: 15
    };
  } else if (position === "left") {
    positionStyle = {
      alignItems: "flex-start",
      paddingLeft: 15
    };
  } else if (position === "rightInner") {
    positionStyle = {
      alignItems: "flex-end"
    };
  }

  if (type === "loading")
    return (
      <View style={[styles.button, positionStyle, style]}>
        <ActivityIndicator color={buttonColor} />
      </View>
    );

  // Default to an icon
  let onPressFunction = onPress;
  let content = (
    <Icon
      icon={type === "help" ? "dc7a5faf-3cf8-41b7-9428-86959f29441f" : icon}
      size={ICON_SIZE}
      color={buttonColor}
    />
  );
  if (type === "loading") {
    onPressFunction = () => {};
    content = (
      <View style={[styles.button, positionStyle, style]}>
        <ActivityIndicator color={buttonColor} />
      </View>
    );
  } else if (type === "help") {
    const { title, message, url, isContactUs, isSchool } = data;
    onPressFunction = () => {
      if (Platform.OS === "web") {
        if (url) window.open(url, "_blank");
        else if (isContactUs && navigation) navigation.push("help", { isSchool });
        return;
      }
      const buttons = [
        {
          text: "Done",
          onPress: () => {
            Analytics.logEvent("touch_HelpButton", {
              title,
              message,
              action: "Done"
            });
          }
        }
      ];
      if (url && navigation)
        buttons.push({
          text: "Learn More",
          onPress: () => {
            const { push } = navigation;
            Analytics.logEvent("touch_HelpButton", {
              title,
              message,
              action: "LearnMore"
            });
            push("webNav", { title, url });
          }
        });
      else if (isContactUs && navigation)
        buttons.push({
          text: "Contact Us",
          onPress: () => {
            Analytics.logEvent("touch_HelpButton", {
              title,
              message,
              action: "ContactUs"
            });
            navigation.push("help", { isSchool });
          }
        });
      Util.alert(title, message, buttons);
    };
  } else if (type === "custom") {
    content = customContent;
  }

  return (
    <TouchableOpacity
      style={[styles.button, positionStyle, style]}
      activeOpacity={0.6}
      onPress={onPressFunction}
    >
      {content}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    width: "100%",
    height: "100%",
    justifyContent: "center"
  }
});
